import { useTranslation } from '@i18n'
import AmpLightBoxAdCloseButton from './AmpLightBoxAdCloseButton'
import AmpLightBoxAdContainer from './AmpLightBoxAdContainer'

interface AmpArticleInterstitialAdProps {
  isR18Article?: boolean
  isLoveSite?: boolean
}

export default function AmpArticleInterstitialAd({
  isR18Article,
  isLoveSite,
}: AmpArticleInterstitialAdProps) {
  const { t } = useTranslation('post')

  const getAdSlot = () => {
    if (isR18Article) return '/90969475/amp_18adult_All_MB_Interstitials'
    if (isLoveSite) return '/90969475/amp_love_All_MB_Interstitials'
    return '/90969475/amp_All_MB_Interstitials'
  }

  const linkHtml = `
    <a
      [href]="interstitialState.destinationUrl"
      style="display: inline-block; padding: 12px 24px; background: #7d7af4; color: white; text-decoration: none; border-radius: 50px; font-size: 16px; font-weight: 500;"
    >
      ${t('ampInterstitialAd.continue')}
    </a>
  `

  return (
    <>
      {/* Interstitial ad state */}
      <amp-state id="interstitialState">
        <script
          type="application/json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({ destinationUrl: '' }),
          }}
        />
      </amp-state>
      {/* lightbox content */}
      <amp-lightbox
        id="interstitialAdLightbox"
        layout="nodisplay"
        style={{ position: 'relative', zIndex: 9999, background: 'rgba(0,0,0,0.8)' }}
      >
        <AmpLightBoxAdCloseButton on="tap:interstitialAdLightbox.close" />
        <AmpLightBoxAdContainer>
          <amp-ad width="336" height="280" type="doubleclick" data-slot={getAdSlot()} />
          <div
            dangerouslySetInnerHTML={{
              __html: linkHtml,
            }}
          />
        </AmpLightBoxAdContainer>
      </amp-lightbox>
    </>
  )
}
